/**
 * Regla de precio:
 * 1 pieza = $26
 * 5 piezas = $100
 * Se pueden combinar productos: 5 piezas totales cuestan $100.
 *
 * Ejemplos:
 * 1 => 26
 * 4 => 104
 * 5 => 100
 * 6 => 126
 * 10 => 200
 */
export const calculateKermesTotal = (quantity) => {
    const qty = Math.max(0, Number(quantity) || 0);

    const packages = Math.floor(qty / 5);
    const individual = qty % 5;

    return packages * 100 + individual * 25;
};

export const calculateKermesChange = (total, payment) => {
    const totalCents = Math.round(Number(total || 0) * 100);
    const paymentCents = Math.round(Number(payment || 0) * 100);

    return Math.max(
        0,
        (paymentCents - totalCents) / 100
    );
};